var map = {
	"./": 1354,
	"./ErrorPage": 9751,
	"./ErrorPage.tsx": 9751,
	"./admin/auth/login": 2456,
	"./admin/auth/login.tsx": 2456,
	"./admin/blocked_date": 7445,
	"./admin/blocked_date/": 7445,
	"./admin/blocked_date/index": 7445,
	"./admin/blocked_date/index.tsx": 7445,
	"./admin/catering": 4405,
	"./admin/catering/": 4405,
	"./admin/catering/catering": 1486,
	"./admin/catering/catering.tsx": 1486,
	"./admin/catering/credit": 240,
	"./admin/catering/credit.tsx": 240,
	"./admin/catering/index": 4405,
	"./admin/catering/index.tsx": 4405,
	"./admin/catering/show": 6303,
	"./admin/catering/show.tsx": 6303,
	"./admin/menu": 3927,
	"./admin/menu/": 3927,
	"./admin/menu/create": 2948,
	"./admin/menu/create.tsx": 2948,
	"./admin/menu/edit": 7097,
	"./admin/menu/edit.tsx": 7097,
	"./admin/menu/index": 3927,
	"./admin/menu/index.tsx": 3927,
	"./admin/reservations": 4656,
	"./admin/reservations/": 4656,
	"./admin/reservations/index": 4656,
	"./admin/reservations/index.tsx": 4656,
	"./cancel_reservation": 7325,
	"./cancel_reservation.tsx": 7325,
	"./catering": 3993,
	"./catering.tsx": 3993,
	"./eventy": 8243,
	"./eventy.tsx": 8243,
	"./index": 1354,
	"./index.tsx": 1354,
	"./kontakt": 6628,
	"./kontakt.tsx": 6628,
	"./menu": 4580,
	"./menu.tsx": 4580,
	"./pribeh": 6807,
	"./pribeh.tsx": 6807,
	"./reservation_is_canceled": 406,
	"./reservation_is_canceled.tsx": 406,
	"./rezervace": 3711,
	"./rezervace.tsx": 3711,
	"./under-construction": 8143,
	"./under-construction.tsx": 8143
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8616;